import { useQuery } from '@tanstack/react-query';
import { get } from '@/shared/api/api-client';
import type { Practice } from '@/types/settings-api';

/**
 * Full Practice record by id.
 *
 * `GET /api/v1/Practice/Details/{practiceSetupId}`
 *
 * Ported from dev-scrips-pm-react `src/settings/services/use-practice.ts`
 * (PROD-758) for PROD-1724 — the consent fill/sign flow reads
 * `practiceSetupDetail.practiceStampUrl` off this record to auto-source the
 * clinic-stamp box. PM's create/update mutations are deliberately NOT ported:
 * PA has no practice-edit surface, so an unreachable mutation would be dead
 * code. Add them alongside the screen that needs them.
 */
export function usePractice(practiceSetupId: string | null | undefined) {
  return useQuery({
    queryKey: ['settings', 'practice-by-id', practiceSetupId],
    queryFn: ({ signal }) => {
      if (!practiceSetupId) throw new Error('usePractice called without practiceSetupId');
      return get<Practice>(`/api/v1/Practice/Details/${practiceSetupId}`, { signal });
    },
    enabled: !!practiceSetupId,
  });
}
